import React, { useState } from "react";
import FeedbackModal from "./FeedbackModal";
import "./FeedbackBanner.scss";

export default function FeedbackBanner() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className="feedback-banner"
        onClick={() => setOpen(true)}
      >
        <span className="feedback-banner__icon">💡</span>
        <span className="feedback-banner__text">
          Є ідеї або помітили баг? Напишіть💬
        </span>
      </button>

      {open && <FeedbackModal onClose={() => setOpen(false)} />}
    </>
  );
}